/**
 * Где в поле ввода стоит символ с номером position — относительно рамки поля, без учёта
 * прокрутки. Сам textarea этого не говорит, поэтому текст до позиции раскладывается
 * в невидимом двойнике-div с теми же шрифтом, шириной и переносами, и меряется метка за ним.
 */
export function caretOffset(el: HTMLTextAreaElement, position: number): { top: number; left: number; height: number } {
  const style = getComputedStyle(el)
  const mirror = document.createElement('div')
  for (const name of COPY) mirror.style.setProperty(name, style.getPropertyValue(name))
  mirror.style.position = 'absolute'
  mirror.style.top = '0'
  mirror.style.left = '-9999px'
  mirror.style.visibility = 'hidden'
  mirror.style.overflow = 'hidden'
  // ширина строки — как у текста в поле, без полосы прокрутки
  mirror.style.boxSizing = 'content-box'
  mirror.style.width = `${el.clientWidth - parseFloat(style.paddingLeft) - parseFloat(style.paddingRight)}px`
  mirror.textContent = el.value.slice(0, position)
  const marker = document.createElement('span')
  marker.textContent = el.value.slice(position) || '.'
  mirror.appendChild(marker)
  document.body.appendChild(mirror)
  const result = {
    top: marker.offsetTop + parseFloat(style.borderTopWidth),
    left: marker.offsetLeft + parseFloat(style.borderLeftWidth),
    height: parseFloat(style.lineHeight) || marker.offsetHeight,
  }
  mirror.remove()
  return result
}

const COPY = [
  'direction', 'padding-top', 'padding-right', 'padding-bottom', 'padding-left',
  'border-top-width', 'border-right-width', 'border-bottom-width', 'border-left-width', 'border-style',
  'font-family', 'font-size', 'font-style', 'font-weight', 'font-stretch', 'font-variant', 'font-feature-settings',
  'letter-spacing', 'word-spacing', 'line-height', 'text-align', 'text-indent', 'text-transform', 'text-rendering',
  'tab-size', 'white-space', 'word-break', 'overflow-wrap',
]
